import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from './themeContext';

/** `{ mode, resolved, setMode, toggle }`. Debe usarse dentro de `<ThemeProvider>`. */
export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext);
  if (!value) throw new Error('useTheme debe usarse dentro de <ThemeProvider>.');
  return value;
}
